(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const init = () => {
    // Тільки хедер, тільки dropdown через <details>
    document
      .querySelectorAll('header details')
      .forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;

        // Щоб не зачепити не-менюшні details (якщо є)
        // В Dawn-подібних темах dropdown має підменю з класом header__submenu / mega-menu__content
        const hasSubmenu =
          details.querySelector('.header__submenu, .mega-menu__content, .list-menu--disclosure');
        if (!hasSubmenu) return;

        // Hover open/close тільки на desktop
        details.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('mouseleave', () => {
          if (!isDesktop()) return;
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        });
      });
  };

  // ініціалізація
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
